import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import HomePage from './pages/HomePage';
import DemoForm from './pages/DemoForm';
import Login from './pages/Login';
import AllFeatures from './pages/AllFeatures';
import SchoolManagement from './pages/SchoolManagement';
import AstravisionDemo from './pages/AstravisionDemo';
import SchoolDashboard from './components/SchoolDashboard';
import SchoolLoginDesign1 from './components/SchoolLoginDesign1';
import SchoolLoginDesign2 from './components/SchoolLoginDesign2';
import SchoolLoginDesign3 from './components/SchoolLoginDesign3';
import SchoolLoginDesign4 from './components/SchoolLoginDesign4';
import SchoolLoginDesign5 from './components/SchoolLoginDesign5';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AstravisionDemo />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/demo-form" element={<DemoForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/school-management/all-features" element={<AllFeatures />} />
        <Route path="/school-management/overview" element={<SchoolManagement />} />
        <Route path="/school-management" element={<HomePage />} />
        <Route path="/school-management/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/astravision-demo" element={<AstravisionDemo />} />
        <Route path="/astravision" element={<AstravisionDemo />} />
        <Route path="/dashboard" element={<SchoolDashboard />} />
        <Route path="/login-design-1" element={<SchoolLoginDesign1 />} />
        <Route path="/login-design-2" element={<SchoolLoginDesign2 />} />
        <Route path="/login-design-3" element={<SchoolLoginDesign3 />} />
        <Route path="/login-design-4" element={<SchoolLoginDesign4 />} />
        <Route path="/login-design-5" element={<SchoolLoginDesign5 />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
